import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { IChatMessage } from '../../hooks/ai-search/use-chat';
import { ChatMessageComponent } from './chat-message';
import ChatComplianceBox, { ChatComplianceBoxProps } from './chat-compliance-box';

export interface IChatMessagesProps {
  messages: IChatMessage[];
  isLoading: boolean;
  onChatFeedbackChange: (msg: IChatMessage) => Promise<void>;
  chatComplianceBoxProps?: ChatComplianceBoxProps;
}

export function ChatMessages(props: IChatMessagesProps) {
  const { messages, isLoading, onChatFeedbackChange, chatComplianceBoxProps } = props;
  const lastMessageIndex = messages && messages.filter(msg => msg.content).length - 1;

  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const prevMessagesLength = useRef(messages.length);
  const prevLastMessageContentLength = useRef(messages[messages.length - 1]?.content.length || 0);

  useEffect(() => {
    if (messagesEndRef.current) {
      const lastMessage = messages[messages.length - 1];
      const prevLastMessageContentLengthValue = prevLastMessageContentLength.current;

      if (messages.length > prevMessagesLength.current || (lastMessage && lastMessage.content.length !== prevLastMessageContentLengthValue)) {
        messagesEndRef.current.scrollIntoView();
      }

      prevMessagesLength.current = messages.length;
      prevLastMessageContentLength.current = lastMessage?.content.length || 0;
    }
  }, [messages]);

  return (
    <Box role="log" aria-live="polite" aria-label="Chatbeskeder" sx={{ pr: 3, pt: 3, overflowY: 'auto', flexGrow: 1 }}>
      {chatComplianceBoxProps && <ChatComplianceBox {...chatComplianceBoxProps} />}
      {messages
        .filter(x => x.content || x.isPreparingReply)
        .map((msg, index) => (
        // eslint-disable-next-line react/no-array-index-key
          <span key={index}>
            <ChatMessageComponent
              showCitations={msg.citations && msg.citations?.length > 0 && !isLoading}
              message={msg}
              isAssistant={msg.role === 'Assistent'}
              onChatFeedbackChange={onChatFeedbackChange}
            />
          <span ref={lastMessageIndex === index ? messagesEndRef : null} />
          </span>
        ))}
    </Box>
  );
}
